import { OAuth2 } from '@backstage/core-app-api';
import {
  BackstageIdentityApi,
  OpenIdConnectApi,
  ProfileInfoApi,
  SessionApi,
} from '@backstage/core-plugin-api';
import {
  ApiBlueprint,
  configApiRef,
  coreExtensionData,
  createExtension,
  createApiRef,
  createFrontendModule,
  discoveryApiRef,
  oauthRequestApiRef,
} from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import LockIcon from '@material-ui/icons/Lock';
import { ProviderSettingsItem } from '@backstage/plugin-user-settings';
import { RdapSignInPage } from './RdapSignInPage';
import { LocalAuthClient, localAuthApiRef } from './localAuthApi';

export const cognitoAuthApiRef = createApiRef<
  OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
>().with({
  id: 'auth.cognito',
});

const cognitoAuthApi = ApiBlueprint.make({
  name: 'cognito',
  params: defineParams =>
    defineParams({
      api: cognitoAuthApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
        OAuth2.create({
          configApi,
          discoveryApi,
          oauthRequestApi,
          environment: configApi.getOptionalString('auth.environment'),
          provider: {
            id: 'cognito',
            title: 'Cognito',
            icon: () => null,
          },
          defaultScopes: ['openid', 'profile', 'email'],
        }),
    }),
});

const localAuthApi = ApiBlueprint.make({
  name: 'local',
  params: defineParams =>
    defineParams({
      api: localAuthApiRef,
      deps: { discoveryApi: discoveryApiRef },
      factory: ({ discoveryApi }) => new LocalAuthClient(discoveryApi),
    }),
});

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => RdapSignInPage,
  },
});

const cognitoProviderSettings = createExtension({
  name: 'cognito-provider-settings',
  attachTo: {
    id: 'sub-page:user-settings/auth-providers',
    input: 'providerSettings',
  },
  output: [coreExtensionData.reactElement],
  factory() {
    return [
      coreExtensionData.reactElement(
        <ProviderSettingsItem
          title="Cognito"
          description="Provides authentication towards Cognito APIs and identities"
          icon={LockIcon}
          apiRef={cognitoAuthApiRef}
        />,
      ),
    ];
  },
});

export const appModuleOidc = createFrontendModule({
  pluginId: 'app',
  extensions: [
    cognitoAuthApi,
    localAuthApi,
    signInPage,
    cognitoProviderSettings,
  ],
});
